import { blackColors, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const addNumbersDialogStyle = (theme) => ({
	addNumbersDialog: {
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 28,
			paddingRight: 28,
		},
		[theme.breakpoints.up('sm')]: {
			paddingLeft: 56,
			paddingRight: 56,
		},
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 6,
			paddingRight: 6,
		},
	},
	accountPicker: {
		marginTop: 8,
		paddingTop: 9,
		marginBottom: 24,
		backgroundColor: whiteColor,
		'& .MuiInputBase-root': {
			paddingLeft: 17,
		},
		width: '288px',
		maxWidth: '75%',
	},
	filterBy: {
		padding: 0,
	},
	customNumbersContainer: {
		'& > div': {
			display: 'inline-block',
		},
		'& > div:first-of-type': {
			width: '288px',
			maxWidth: '75%',
		},
		'& > div:nth-of-type(2)': {
			width: '25%',
		},
	},
	addCustomNumber: {
		paddingTop: 20,
	},
	allNumbers: {
		marginTop: 3,
	},
	customNumber: {
		width: '100px',
		display: 'inline-block',
		marginRight: 4,
	},
	numberTag: {
		width: 100,
	},
	noDepartments: {
		height: 370,
		paddingTop: 114,
	},
	numbersPhone: {
		height: 16,
		width: 16,
		color: blackColors[4],
		marginRight: 8,
		position: 'relative',
		top: 3,
	},
	departmentName: {
		display: 'flex',
		alignItems: 'center',
		'& svg': {
			marginRight: 8,
		},
	},
	departmentIcon: {
		width: 32,
		height: 32,
		borderRadius: 4,
		padding: 10,
		color: whiteColor,
	},
	selectedRow: {
		background: `linear-gradient(${blackColors[6]}, ${blackColors[6]}), linear-gradient(white, white)`,
	},
	selectedItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& svg': {
			color: blackColors[4],
			width: '24px',
			height: '24px',
			marginRight: '8px',
		},
	},
	selectedItemIcon: {
		height: 24,
		width: 24,
		marginRight: 8,
	},
});

export default addNumbersDialogStyle;
